import ApiUrl from "../../../../configTools/api";
const User = JSON.parse(localStorage.getItem("user-info"));



const Post = (body,toast,toastid,reset) => {
    fetch(ApiUrl.LabAdmin_Orders,{
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer '+User.token
        },
        body: JSON.stringify(body)
    })
    .then(res=>res.json())
    .then(data =>{
        if(data.success){
            setTimeout(() => {
              toast.update(toastid, { render: "Added", type: "success", isLoading: false, autoClose:2000, position: toast.POSITION.BOTTOM_CENTER });
            }, 500);
            reset();
        }
        else{
            setTimeout(() => {
              toast.update(toastid, { render: data.response, type: "error", isLoading: false, autoClose:2000, position: toast.POSITION.BOTTOM_CENTER });
            }, 500);
        }
    });
}

const GetById = (id, setOrderData) => {
    fetch(ApiUrl.LabAdmin_Orders + "/" + id, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + User.token
        }
    })
    .then(res => res.json())
    .then(data => {
        if(data.success && data.response && data.response.length > 0){
            setOrderData(data.response[0]);
        }
    });
}

const Put = (body, toast, toastid, reset) => {
    fetch(ApiUrl.LabAdmin_Orders, {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + User.token
        },
        body: JSON.stringify(body)
    })
    .then(res => res.json())
    .then(data => {
        if(data.success){
            setTimeout(() => {
              toast.update(toastid, { render: "Order updated", type: "success", isLoading: false, autoClose:2000, position: toast.POSITION.BOTTOM_CENTER });
            }, 500);
            reset();
        } else {
            setTimeout(() => {
              toast.update(toastid, { render: data.response || "Update failed", type: "error", isLoading: false, autoClose:2000, position: toast.POSITION.BOTTOM_CENTER });
            }, 500);
        }
    });
}

const Functions = {Post, GetById, Put};
export default Functions;